module.exports = __webpack_public_path__ + "media/images/avatar/28-4968402a979f33078999c7e68f79ee27.svg";